import * as React from 'react';
export const usdtSvg = React.forwardRef(function usdtSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#50AF95',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.035 16.745c-.114.009-.701.044-2.01.044-1.043 0-1.782-.032-2.042-.044-4.025-.177-7.03-.878-7.03-1.717 0-.839 3.005-1.539 7.03-1.719v2.738c.264.02 1.017.064 2.06.064 1.25 0 1.875-.052 1.988-.063v-2.737c4.017.18 7.015.88 7.015 1.717 0 .837-2.997 1.538-7.015 1.716l.004.001Zm0-3.717v-2.45h5.606V6.842H8.377v3.736h5.605v2.45C9.426 13.235 6 14.138 6 15.22s3.426 1.984 7.982 2.194v7.85h4.052v-7.853c4.545-.21 7.966-1.11 7.966-2.191 0-1.081-3.418-1.982-7.966-2.193v.001Z',
      fill: '#fff',
    }),
  );
});
usdtSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usdt = {
  category: 'brand',
  colorable: false,
  name: 'usdt',
  svg: usdtSvg,
};
